import React from 'react'
import DateFieldValidate from '../../../../../../validate/form/date/DateFieldValidate'
import { useState } from 'react'
import { getDateOnly } from '../../../../../../../helpers/date/dateHelper'

const DeliveryDateDeadlineField = ({ required, setValidate, setValueForm, forciblyValue }) => {

    const [value, setValue] = useState('')

    // console.log('value', value)

  return (
    <DateFieldValidate
        value={value}
        label={'Дата планова'}
        setValidate={setValidate}
        setValue={e => {
            // console.log('e', e)
            // setValueForm(e)
            setValueForm(getDateOnly(e))
            setValue(getDateOnly(e))
        }}
        required={required}
		minDateType={'today'}
        // maxDateType={18}
        validates={{
            // isDateBirth18: true
        }}
        forciblyValue={forciblyValue}
    />
  )
}

export default DeliveryDateDeadlineField